export default "/fonts/vendor/primeicons/primeicons.eot?ff0c4cd79b2ffca2de5464471f656e8b";